import { CircularProgress, MuiAlert, strIsNullOrEmpty } from '@fox/atoms';
import { Flex } from '@fox/layout';
import React, { useEffect, useState } from 'react';
import { useContentContext } from '../../content-context';
import { redirect } from '../membership-form-template/util';
import { ILinkLoginRedirectProps } from './contracts';

export const LinkLoginRedirect: React.FC<ILinkLoginRedirectProps> = ({ memberId, redirectUrl, token, originContentId }) => {
	const { contentId, requestToken } = useContentContext();
	const [error, setError] = useState<string>('');
	useEffect(() => {
		const login = async function () {
			const resp = await fetch('/Umbraco/Api/Membership/HandleTwoFactorEmailLogin', {
				method: 'POST',
				headers: {
					Accept: 'application/json',
					'Content-Type': 'application/json',
					RequestVerificationToken: requestToken
				},
				body: JSON.stringify({ memberId, redirectUrl, token, contentId, originContentId })
			});
			if (!resp.ok) {
				setError('Error trying to log in, please contact support');
			} else {
				const jsonRes = await resp.json();
				if (jsonRes.success === false) {
					setError(`${jsonRes?.message ?? ''}`);
				} else if (!strIsNullOrEmpty(jsonRes.result)) {
					redirect({ url: jsonRes.result });
				} else if (!strIsNullOrEmpty(redirectUrl?.url)) {
					redirect(redirectUrl);
				}
			}
		};
		login();
	}, []);

	return (
		<Flex style={{ width: '100%', justifyContent: 'center', alignItems: 'center', minHeight: '100vh' }}>
			{error ? <MuiAlert severity="error">{error}</MuiAlert> : <CircularProgress />}
		</Flex>
	);
};
